// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterBackground_container__6CDUl"};